import React from 'react'

import styles from './oktaStyleWrapper.module.scss'

type Props = {
  children: React.ReactNode
  customClass?: string
}

const OktaStyleWrapper = ({ children, customClass, ...props }: Props) => {
  return (
    <div {...props} className={customClass ?? styles['okta-wrapper']}>
      {children}
    </div>
  )
}

export default OktaStyleWrapper
